import axios from '../utils/axios';

export default function updateCourse(adminId, courseId, data) {
    return axios.post('/admin/' + adminId + '/courses/course/' + courseId, data)
}